export enum PosDeviceTypeEnum {
  POS = 1,
  MOBILE_POS = 2,
  KIOSK = 3,
  STOCK = 4,
  PURCHASING = 5,
  ORDER_WATCHER = 6,
  CRAVE_CARDS = 7,
  ALLREV_CASH_UP = 8,
  SWEET_FACE = 9,
  ONLINE = 10,
}
